export default __webpack_public_path__ + "static/media/drupal-original.c4ac387f.svg";